import SchemaCard from './SchemaCard';
import EventCard from '../EventCard';

export default function SchemaDragOverlay({ activeDragItem }) {
  if (!activeDragItem) return null;

  if (activeDragItem.type === 'schema') {
    return <SchemaCard schema={activeDragItem.schema} isDragOverlay />;
  }

  return (
    <EventCard event={activeDragItem.event} onEdit={() => {}} onDelete={() => {}} isDragOverlay />
  );
}
